import axiosInstance from "src/utils/axios";
import { API_URLS } from "../api-urls";

export const refreshToken = async () => {
  const csrf_token = localStorage.getItem("csrf_token");

  return axiosInstance
    .post(API_URLS.REFRESH, undefined, {
      headers: {
        "X-CSRF-TOKEN": csrf_token,
      },
    })
    .then((res: any) => {
      localStorage.setItem("csrf_token", res.csrf_token);
      return res;
    });
};
